import IconButton from 'Components/Atoms/IconButton/IconButton';
import OutlineArrowRight from 'Components/Atoms/OutlineIcons/OutlineArrowRight';
import OutlineCloseSmall from 'Components/Atoms/OutlineIcons/OutlineCloseSmall';
import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';

export default function AISuggestionsDrawerItem(props) {
    const { className, onClick, title, label, image, onClose } = props;

    return (
        <div className="relative group">
            <button
                type="button"
                className={cn(
                    'group text-left inline-flex items-center justify-center rounded-lg focus-visible:outline-none focus-visible:ring-2 disabled:pointer-events-none disabled:opacity-75 ring-primary/20 focus-visible:border-primary transition-all relative bg-white border border-gray-200 shadow-sm hover:bg-gray-50 text-dark-blue',
                    'py-3.5 px-4 w-full gap-3 justify-between',
                    className,
                )}
                onClick={onClick}
            >
                <div className="flex items-center gap-3 min-w-0">
                    <div className="flex-shrink-0 size-12 [&>*]:h-full [&>*]:w-full [&>*]:object-contain">{image}</div>
                    <div className="flex flex-col min-w-0">
                        <div className="opacity-50 mt-1 text-sm">{label}</div>
                        <div className="text-base font-semibold">{title}</div>
                    </div>
                </div>
                <div className="shrink-0 pl-6">
                    <div className="transition-transform duration-200 ease-in-out group-hover:translate-x-1">
                        <OutlineArrowRight size={20} className="text-dark-blue" />
                    </div>
                </div>

                <div className="absolute top-2 left-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="none" viewBox="0 0 15 15">
                        <path
                            fill="#FF8A00"
                            fillRule="evenodd"
                            stroke="#FF8A00"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="0.5"
                            d="M6.05 10.103 5.509 12l-.543-1.897A3 3 0 0 0 2.9 8.043L1 7.5l1.9-.542a3 3 0 0 0 2.064-2.06L5.508 3l.543 1.897a3 3 0 0 0 2.063 2.06l1.901.543-1.9.542a3 3 0 0 0-2.064 2.06zm5.641-4.793-.173.69-.173-.69a2.25 2.25 0 0 0-1.64-1.637L9.015 3.5l.692-.173a2.25 2.25 0 0 0 1.64-1.637l.172-.69.173.69a2.25 2.25 0 0 0 1.64 1.637l.691.173-.69.173A2.25 2.25 0 0 0 11.69 5.31m-.912 7.901-.263.789-.263-.789c-.15-.448-.501-.799-.95-.948L8.513 12l.79-.263c.449-.149.8-.5.95-.948l.263-.789.264.789c.149.448.501.799.95.948l.79.263-.79.263c-.449.149-.801.5-.95.948"
                            clipRule="evenodd"
                        ></path>
                    </svg>
                </div>
            </button>
            <IconButton
                icon={<OutlineCloseSmall />}
                className="absolute top-0.5 right-0.5 size-6 group-hover:opacity-100 opacity-0 transition-opacity -translate-y-1/2 translate-x-1/2 rounded-full"
                onClick={onClose}
            />
        </div>
    );
}

AISuggestionsDrawerItem.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    onClose: PropTypes.func,
    title: PropTypes.string,
    label: PropTypes.string,
    image: PropTypes.node,
};
